import type { AxiosInstance } from 'axios';
import { getAPIAuthToken } from '@core/auth/config';
import { ensureRequestHeaders } from './ensureRequestHeaders';

// Shared by client.ts and NextClient.ts: adds the internal API secrets
// token header to outgoing requests when one is available. Extracted to a
// single implementation so the two clients don't carry a byte-for-byte
// duplicate of this interceptor.
export const addAuthorizationHeaderInterceptor = (client: AxiosInstance): void => {
  client.interceptors.request.use(request => {
    const token = getAPIAuthToken();
    if (token) {
      ensureRequestHeaders(request)['X-Secrets-Authorization'] = token;
    }
    return request;
  });
};
